export default {
  state: {
    cards: [],
    newCard: {}
  },
  mutations: {
    setCards (state, cards) {
      state.cards = cards
    },
    setNewCardValues (state, data) {
      state.newCard[data.id] = data.value
    },
    clearNewCardValues (state) {
      state.newCard = {}
    },
    pushCardMock (state, card) {
      state.cards.push(card)
    },
    deleteCardMock (state, index) {
      state.cards.splice(index, 1)
    }
  },
  actions: {
    setCards ({ commit }, cards) {
      commit('setCards', cards)
    },
    setNewCardValues ({ commit }, data) {
      commit('setNewCardValues', data)
    },
    clearNewCardValues ({ commit }) {
      commit('clearNewCardValues')
    },
    pushCardMock ({ commit }, card) {
      commit('pushCardMock', card)
    },
    deleteCardMock ({ commit }, index) {
      commit('deleteCardMock', index)
    }
  },
  getters: {
    userCardList: (state) => state.cards,
    newCardValues: (state) => state.newCard
  }
}
